import Cookies from 'js-cookie';

const $cookies = document.querySelector('.cookies');
const $button = document.querySelector('.cookies__button');

const accept = () => {
	$cookies.classList.remove('is-active');

	Cookies.set('cookiesAccept', true, {expires: 365});
};

const init = () => {
	if ($cookies === null || typeof Cookies.get('cookiesAccept') !== 'undefined') {
		return;
	}

	$cookies.classList.add('is-active');

	$button.addEventListener('click', accept, {
		once: true,
	});
};

export default {
	init,
};
